
import instance from "./api";

const endpoints = {
  configuration: (projectId, sport) =>
    `${process.env.REACT_APP_API_URL}/api/projects/${projectId}/matchcentre/${sport}/configuration`,
  content: (projectId, sport, contentKey) =>
    `${process.env.REACT_APP_API_URL}/api/projects/${projectId}/matchcentre/${sport}/configuration/${contentKey}/content`,
  events: (projectId, sport) =>
    `${process.env.REACT_APP_API_URL}/api/projects/${projectId}/matchcentre/${sport}/events`,
  sources: (projectId, sport) =>
    `${process.env.REACT_APP_API_URL}/api/projects/${projectId}/matchcentre/${sport}/sources`,
};

const fetchMatchCenterConfiguration = async (projectId, sport, params) => {
  const queryParams = params
    ? params.map((x) => `${x.key}=${x.value}`).join("&")
    : "";
  const endpoint = endpoints.configuration(projectId, sport);
  const res = await instance.get(
    `${endpoint}${queryParams ? `?${queryParams}` : ""}`
  );
  return res.data;
};

const fetchMatchCenterContent = async (projectId, sport, contentKey, params) => {
  const queryParams = params
    ? params.map((x) => `${x.key}=${x.value}`).join("&")
    : "";
  const endpoint = endpoints.content(projectId, sport, contentKey);
  const res = await instance.get(
    `${endpoint}${queryParams ? `?${queryParams}` : ""}`
  );
  return res.data;
};

const fetchMatchCenterEvents = async (projectId, sport, params) => {
  const queryParams = params
    ? params.map((x) => `${x.key}=${x.value}`).join("&")
    : "";
  const endpoint = endpoints.events(projectId, sport);
  const res = await instance.get(
    `${endpoint}${queryParams ? `?${queryParams}` : ""}`
  );
  return res.data;
};

const fetchMatchCenterSources = async (projectId, sport, params) => {
  // return ['source 1', 'source 2', 'source 3', 'source 4', 'source 5', 'source 6', 'source 7'];
  const queryParams = params
    ? params.map((x) => `${x.key}=${x.value}`).join("&")
    : "";
  const endpoint = endpoints.sources(projectId, sport);
  const res = await instance.get(
    `${endpoint}${queryParams ? `?${queryParams}` : ""}`
  );
  return res.data;
};

const setMatchCenterConfiguration = async (projectId, sport, data) => {
  const res = await instance.post(endpoints.configuration(projectId, sport), data);
  return res.data;
};

const setMatchCenterContent = async (projectId, sport, contentKey, data) => {
  const res = await instance.put(endpoints.content(projectId, sport, contentKey), data);
  return res.data;
};

export {
  fetchMatchCenterConfiguration,
  setMatchCenterConfiguration,
  fetchMatchCenterEvents,
  fetchMatchCenterContent,
  setMatchCenterContent,
  fetchMatchCenterSources
};
